<template>
  <div class="report-middle-section p-1 bg-gray-300 border-none mb-0 mt-4" :class="{ 'bg-yellow-300' : outlier }">
    <h4 class="text-center pt-0 mt-0">{{ name }}</h4>
    <div class="sterlingbars-wrapper sterlingbars-feedback">
      <div class="trait-wrapper">
        <div class="trait-bar">
          <div class="trait-score" :style="{ left: percentagescore }">
            <i aria-hidden="true" class="material-icons pr-0">stars</i>
          </div>
          <div v-if="std" class="trait-spread" :style="{ width: spreadwidth, left: spreadleft }"> &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- For Yellow Bars - IF( (userScore<(avg-std) OR userScore>(avg+std) ) -->
<script>
export default {

  props: {
    name: '',
    avg: '',
    std: '',
    score: '',
  },
  data() {
    return {
      avgFloat: parseFloat(this.avg),
      stdFloat: parseFloat(this.std)
    }
  },
  computed: {
    percentagescore : function() {
      return (this.score) + '%';
    },
    spreadwidth : function() {
      return (this.std) * 2 + '%';
    },
    spreadleft : function() {
      return (this.avg) - (this.std) + '%';
    },
    outlierleft : function() {
      return (this.avg - this.std);
    },
    outlierright : function() {
      return (this.avgFloat + this.stdFloat);
    },
    outlier : function() {
      return (this.score) < (this.avgFloat - this.stdFloat) || (this.score) > (this.avgFloat + this.stdFloat);
    }
  },

};
</script>
